import React from 'react';
import { CrzpMarker } from '../map-types';

export interface MarkerPopupConfig<DATA> {
  fetchData: (marker: CrzpMarker) => Promise<DATA>;
  PopupBodyComponent: (props: {
    data: DATA;
    marker: CrzpMarker;
  }) => React.ReactElement;
}

export const useMarkerPopupFactory = <DATA,>({
  fetchData,
  PopupBodyComponent,
}: MarkerPopupConfig<DATA>): MarkerPopupConfig<DATA> => {
  return {
    fetchData: (marker: CrzpMarker) => fetchData(marker),
    PopupBodyComponent,
  };
};
